import {
    SIGN_UP_MUTATION,
    LOGIN_MUTATION,
    SAVE_TOKEN_MUTATION,
    SET_USER_LOGGED_MUTATION,
    LOGOUT_MUTATION,
    SIGN_UP_WITH_FACEBOOK_MUTATION,
    CHANGE_LOGGED_IN_STATUS_MUTATION,
    CHANGE_USER_EDITED_VALUE_MUTATION,
    REMOVE_USER_DETAILS_MUTATION,
    SET_REMAINING_EVENTS_COUNT_MUTATION
} from './mutation.type'

export default {
    [SIGN_UP_MUTATION](state, userDetails) {
        state.userDetails = userDetails;
    },

    [SIGN_UP_WITH_FACEBOOK_MUTATION](state, userDetails) {
        state.userDetails = userDetails;
    },

    [LOGIN_MUTATION](state, userDetails) {
        state.userDetails = userDetails;
    },

    [SAVE_TOKEN_MUTATION](state, token) {
        state.accessToken = token.accessToken;
        state.refreshToken = token.refreshToken
    },

    [SET_USER_LOGGED_MUTATION](state, payload) {
        console.log(payload)
        state.isUserLoggedIn = payload;
    },

    [LOGOUT_MUTATION](state) {
        state.userDetails = null,
            state.accessToken = null,
            state.isUserLoggedIn = false
    },

    [CHANGE_LOGGED_IN_STATUS_MUTATION](state) {
        state.userDetails.isFirstLogin = false
    },

    [CHANGE_USER_EDITED_VALUE_MUTATION](state, payload) {
        // console.log(payload)
        state.userDetails.profileImage = payload.profileImage;
        state.userDetails.name = payload.name;
    },

    [REMOVE_USER_DETAILS_MUTATION](state) {
        state.userDetails = ''
    },
    [SET_REMAINING_EVENTS_COUNT_MUTATION](state, payload) {
        // console.log(payload);
        state.userDetails.remainingEventsCount = payload;
    }
}